import { render, staticRenderFns } from "./SemiContrastCard.vue?vue&type=template&id=891bc23e&scoped=true"
import script from "./SemiContrastCard.vue?vue&type=script&lang=js"
export * from "./SemiContrastCard.vue?vue&type=script&lang=js"
import style0 from "./SemiContrastCard.vue?vue&type=style&index=0&id=891bc23e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891bc23e",
  null
  
)

export default component.exports